import(/* webpackMode: "eager", webpackExports: ["RegisterPageView"] */ "/app/apps/tagea-web/src/libs/features/auth/register/ui/register-page.view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingEmergencyButton"] */ "/app/apps/tagea-web/src/libs/features/emergency/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/apps/tagea-web/src/libs/features/page/Footer.tsx");
